<div class="text-center">

  <h1 mat-dialog-title translate> {{title}} </h1>
  <div id="clipboard-body" class="modal-body p-2" mat-dialog-content>
    
    <ng-container *ngFor = "let value of values">
      <mat-form-field id="clip-form" appearance="outline" class="mt-3">
        <mat-label>{{value.clipboard_label | translate}}</mat-label>
        <input matInput [(ngModel)] = "value.clipboard_text" readonly >
      </mat-form-field>
      <button mat-icon-button class="mt-3">
        <mat-icon (click)="copyToClipboard(value.clipboard_text)"
                  matSuffix>
          content_copy
        </mat-icon>
      </button>  
    </ng-container>


  </div>
  <div class="modal-footer" mat-dialog-actions translate>
    <button autofocus type="button" class="btn btn-outline-secondary"
      (click)="close()" translate>
      {{confirm_text}}
    </button>
  </div>
</div>